import React from "react";
import { StoreContext } from "./StoreContext";
import { useStoreModuleStatus } from "@hooks";

export function StoreProvider({ children }: React.PropsWithChildren) {
  const store = useStoreModuleStatus();
  return (
    <StoreContext.Provider value={{ moduleStatus: store }}>
      {children}
    </StoreContext.Provider>
  );
}
